<!-- 子组件 child.vue -->

<template>
    <div style="width: 304px; height: 400px;background: #FFFFFF;border: 1px solid #CCCCCC;margin-bottom: 20px;">
          <ul class="u-nav-ywdt" style="padding-left:30px;">
              <li  v-for="item in list" :key="item.Word_Value" style="float: left;" >
                <div class="lmenu" >
                  <a @click="datashow(item)"  :title="item.Word_Text" :style="(value == item.Word_Value) ?'color: #DF3E3E;':''">{{ item.Word_Text }}</a>
                  <img src="../assets/about_nav.png" style="width: 26px;height: 13px;" v-show="value == item.Word_Value"/>
                </div>
                <div class="frame-border" :style="(value == item.Word_Value) ?'border: 1px solid #DF3E3E;':''" ></div>         
              </li>               
          </ul>
        </div>
</template>
<script>
export default {
  data: function() {
    return {
    };
  },
  props: ['value','list'],    
  methods: {
    datashow(item)
    {
        // 通过自定义事件addNum把值传给父组件
        this.$emit('datashow',item)
    }    
  }
};
</script>
